import { KpiSenderDto, defaultKpiSenderData } from "src/dtos/kpisender/kpisenderDto";
import { ProductResultDto } from "src/dtos/productResult/ProductResultDto";
import { formatDate, toLocalDateTime } from "src/utils/string/stringUtil";

/**
 * PRD5011 DTO
 * KpiSenderDto를 상속받아 화면 전용 필드를 추가한 인터페이스
 */
export interface PRD5011_R01Dto extends KpiSenderDto {
	rowKey: string;
    compCd: string;
	kpiYn: string;
}

export interface PRD5011_R01ProductResultDto extends ProductResultDto {
	
}

/**
 * PRD5011 DTO 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultPRD5011_R01Data: PRD5011_R01Dto = {
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,

    id: 0,
    kpicertkey: '',
    ocrdttm: '',
    systmopryn: '',
    kpifldcd: '',
    kpidtlcd: '',
    kpidtlnm: '',
    msmtvl: 0,
    unt: '',
    achrt: 0,
    transdt: toLocalDateTime(new Date()),
    transrsltcd: '',
    transrsltmsg: '',
    transrsltdt: toLocalDateTime(new Date()),
    compNm: '',
    remark: '',
	kpiYn: '',
	rowKey: '',
    compCd: '',

	inserted: false,
	isModified: false,
};


export const defaultPRD5011_R01ProductResultDto: PRD5011_R01ProductResultDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productResultNo: '',
	compCd: '',
	compNm: '',
	productDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemStatus: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productOrderNo: '',
	orderQty: 0,
	productEmp: '',
	productEmpNm: '',
	workStartDt: toLocalDateTime(new Date()),
	workEndDt: undefined,
	productQty: 0,
	badQty: 0,
	acceptQty: 0,
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	kpiYn: '',
	inspectQty: 0,
	inspectYn: 'N',
	remark: '',

	inserted: false,
	isModified: false,
}
